import React, { useState } from 'react'
import supabase from '../supabase'

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL
const ANON_KEY    = import.meta.env.VITE_SUPABASE_ANON_KEY

const formatD = (pwd) => {
  if (pwd.length < 12) return 'Minimum 12 caractères'
  if ((pwd.match(/[A-Z]/g)||[]).length < 2) return 'Au moins 2 majuscules'
  if ((pwd.match(/[0-9]/g)||[]).length < 2) return 'Au moins 2 chiffres'
  if (!/[@#$!%*?&]/.test(pwd)) return 'Au moins 1 caractère spécial (@#$!%*?&)'
  if (/(.)\1\1/.test(pwd)) return '3 caractères identiques consécutifs interdits'
  return null
}

const force = (pwd) => {
  let s = 0
  if (pwd.length >= 12) s++; if (pwd.length >= 16) s++
  if ((pwd.match(/[A-Z]/g)||[]).length >= 2) s++
  if ((pwd.match(/[0-9]/g)||[]).length >= 2) s++
  if (/[@#$!%*?&]/.test(pwd)) s++
  if (s <= 2) return { label: 'Faible', color: '#EF4444', pct: 33 }
  if (s <= 3) return { label: 'Moyen', color: '#F59E0B', pct: 60 }
  return { label: 'Fort', color: '#10B981', pct: 100 }
}

const generer = () => {
  const U='ABCDEFGHJKLMNPQRSTUVWXYZ', L='abcdefghjkmnpqrstuvwxyz', D='23456789', S='@#$!%*?&'
  const pick = s => s[Math.floor(Math.random()*s.length)]
  const all = U+L+D+S
  let tries = 0
  while (tries++ < 100) {
    let p = pick(U)+pick(U)+pick(D)+pick(D)+pick(S)
    while (p.length < 14) p += pick(all)
    p = p.split('').sort(()=>Math.random()-0.5).join('')
    if (!formatD(p)) return p
  }
  return 'SOLstice@2026!'
}

export default function SetPasswordPage({ onDone }) {
  const [form,       setForm]       = useState({ nouveau: '', confirm: '' })
  const [showNouv,   setShowNouv]   = useState(false)
  const [showConf,   setShowConf]   = useState(false)
  const [loading,    setLoading]    = useState(false)
  const [error,      setError]      = useState('')
  const [succes,     setSucces]     = useState(false)

  const handleSubmit = async () => {
    const err = formatD(form.nouveau)
    if (err) { setError(err); return }
    if (form.nouveau !== form.confirm) { setError('Les mots de passe ne correspondent pas.'); return }
    setLoading(true); setError('')
    try {
      const raw = localStorage.getItem('solstice-auth')
      const s = raw ? JSON.parse(raw) : null
      const token = s?.access_token || s?.session?.access_token || ''
      const resp = await fetch(`${SUPABASE_URL}/auth/v1/user`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`, 'apikey': ANON_KEY },
        body: JSON.stringify({ password: form.nouveau, data: { first_login: false } }),
      })
      if (!resp.ok) { const b = await resp.json(); throw new Error(b.msg || b.message || `Erreur ${resp.status}`) }
      setSucces(true)
      setTimeout(() => onDone(), 2500)
    } catch (e) { setError('Erreur : ' + e.message) }
    finally { setLoading(false) }
  }

  const errFormat = form.nouveau ? formatD(form.nouveau) : null
  const f = force(form.nouveau)
  const matchOk = form.nouveau && form.confirm && form.nouveau === form.confirm

  const inpStyle = (border) => ({
    width: '100%', padding: '0.8rem 2.5rem 0.8rem 1rem', borderRadius: 10,
    border: `1.5px solid ${border}`, background: 'rgba(255,255,255,0.05)',
    color: 'white', fontSize: '0.9rem', outline: 'none', boxSizing: 'border-box',
  })

  return (
    <div style={{
      minHeight: '100vh', background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Bricolage Grotesque', sans-serif", padding: '1rem',
    }}>
      <div style={{
        background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255,255,255,0.1)', borderRadius: 24,
        padding: '3rem 2.5rem', width: '100%', maxWidth: 460,
        boxShadow: '0 25px 80px rgba(0,0,0,0.5)', position: 'relative', overflow: 'hidden',
      }}>
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 4,
          background: 'linear-gradient(90deg, #FF6B35, #00D4AA, #FF6B35)', backgroundSize: '200% 100%' }} />

        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ fontSize: '2.5rem', fontWeight: 800, letterSpacing: -1,
            background: 'linear-gradient(135deg, #FF6B35, #00D4AA)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', marginBottom: '0.5rem' }}>
            ☀️ SOLSTICE
          </div>
          <h2 style={{ margin: '0 0 0.25rem', fontSize: '1.2rem', fontWeight: 800, color: 'white' }}>
            🔑 Définir votre mot de passe
          </h2>
          <p style={{ margin: 0, color: '#64748B', fontSize: '0.85rem' }}>
            Bienvenue ! Choisissez un mot de passe sécurisé pour accéder à votre compte.
          </p>
        </div>

        {succes ? (
          <div style={{ textAlign: 'center', padding: '1rem 0' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
            <p style={{ color: 'white', fontWeight: 700, margin: '0 0 0.5rem' }}>Mot de passe enregistré !</p>
            <p style={{ color: '#64748B', fontSize: '0.85rem' }}>Redirection vers l'application…</p>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {/* Règles */}
            <div style={{ background: 'rgba(255,107,53,0.06)', border: '1px solid rgba(255,107,53,0.2)',
              borderRadius: 10, padding: '0.75rem 1rem', fontSize: '0.78rem', color: '#94A3B8', lineHeight: 1.6 }}>
              <strong style={{ color: '#FF6B35' }}>Format requis :</strong> ≥12 car. · 2 majuscules · 2 chiffres · 1 spécial (@#$!%*?&)
            </div>

            <button onClick={() => { const g = generer(); setForm({ nouveau: g, confirm: g }); setError('') }}
              style={{ background: 'rgba(124,58,237,0.15)', border: '1px solid rgba(124,58,237,0.35)',
                color: '#C4B5FD', borderRadius: 10, padding: '0.55rem 1rem', cursor: 'pointer',
                fontSize: '0.82rem', fontWeight: 700, textAlign: 'left' }}>
              ✨ Générer un mot de passe sécurisé
            </button>

            {/* Nouveau */}
            <div>
              <label style={{ display: 'block', color: '#94A3B8', fontSize: '0.75rem', marginBottom: '0.4rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Mot de passe</label>
              <div style={{ position: 'relative' }}>
                <input type={showNouv ? 'text' : 'password'} value={form.nouveau} placeholder="Votre mot de passe"
                  onChange={e => { setForm(p => ({ ...p, nouveau: e.target.value })); setError('') }}
                  style={inpStyle(errFormat ? 'rgba(239,68,68,0.5)' : form.nouveau && !errFormat ? 'rgba(16,185,129,0.5)' : 'rgba(255,255,255,0.1)')} />
                <span onClick={() => setShowNouv(v => !v)} style={{ position: 'absolute', right: '0.75rem', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', fontSize: '0.9rem', color: '#64748B' }}>
                  {showNouv ? '🙈' : '👁️'}
                </span>
              </div>
              {form.nouveau && (
                <div style={{ marginTop: '0.4rem' }}>
                  <div style={{ height: 4, borderRadius: 4, background: 'rgba(255,255,255,0.06)', overflow: 'hidden' }}>
                    <div style={{ height: '100%', width: `${f.pct}%`, background: f.color, transition: 'width 0.3s' }} />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.25rem' }}>
                    <span style={{ fontSize: '0.72rem', color: f.color, fontWeight: 700 }}>{f.label}</span>
                    {errFormat && <span style={{ fontSize: '0.72rem', color: '#FCA5A5' }}>⚠️ {errFormat}</span>}
                  </div>
                </div>
              )}
            </div>

            {/* Confirmer */}
            <div>
              <label style={{ display: 'block', color: '#94A3B8', fontSize: '0.75rem', marginBottom: '0.4rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Confirmer le mot de passe</label>
              <div style={{ position: 'relative' }}>
                <input type={showConf ? 'text' : 'password'} value={form.confirm} placeholder="Répéter le mot de passe"
                  onChange={e => { setForm(p => ({ ...p, confirm: e.target.value })); setError('') }}
                  style={inpStyle(form.confirm && !matchOk ? 'rgba(239,68,68,0.5)' : matchOk ? 'rgba(16,185,129,0.5)' : 'rgba(255,255,255,0.1)')} />
                <span onClick={() => setShowConf(v => !v)} style={{ position: 'absolute', right: '0.75rem', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', fontSize: '0.9rem', color: '#64748B' }}>
                  {showConf ? '🙈' : '👁️'}
                </span>
              </div>
              {form.confirm && !matchOk && <p style={{ margin: '0.25rem 0 0', color: '#FCA5A5', fontSize: '0.72rem' }}>⚠️ Les mots de passe ne correspondent pas</p>}
              {matchOk && <p style={{ margin: '0.25rem 0 0', color: '#10B981', fontSize: '0.72rem' }}>✓ Les mots de passe correspondent</p>}
            </div>

            {error && <p style={{ margin: 0, color: '#FCA5A5', fontSize: '0.82rem' }}>⚠️ {error}</p>}

            <button onClick={handleSubmit} disabled={loading || !!errFormat || !matchOk}
              style={{
                background: loading || errFormat || !matchOk ? 'rgba(255,107,53,0.2)' : 'linear-gradient(135deg,#FF6B35,#E55A2B)',
                border: 'none', borderRadius: 12, padding: '0.9rem',
                color: loading || errFormat || !matchOk ? '#64748B' : 'white',
                fontWeight: 700, fontSize: '1rem', cursor: loading || errFormat || !matchOk ? 'not-allowed' : 'pointer',
                marginTop: '0.5rem',
              }}>
              {loading ? '⏳ Enregistrement…' : '✅ Définir mon mot de passe'}
            </button>
          </div>
        )}
      </div>
    </div>
  )
}